import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  isLoading: false,
  systemSettings: [],
};

const slice = createSlice({
  name: 'system-setting',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getSystemSetting(state, action) {
      state.isLoading = false;
      state.systemSettings = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getSystemSettings(queryParams) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('system-settings', { params: queryParams });
      const systemSettings = response?.data?.data || [];

      dispatch(slice.actions.getSystemSetting(systemSettings));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
